<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->

<template>
  <app-card>
    <app-datatable
      ref="datatable"
      :btn-dialog="userHasPermission('store')"
      :form-loading.sync="formLoading"
      :form.sync="dialog"
      :headers="headers"
      :modal-title="datatableDialogTitle"
      :url="tableUrl"
      @submitClickForm="submitClickForm"
    >
      <template #form="props">
        <app-form
          ref="form"
          :errors="formErrors"
          :submit="submitForm"
        >
          <v-container>
            <app-input-avatar
              v-model="selectedItem[getBlobAvatarName]"
              :blob-avatar="blobAvatar"
              :label="isNewItem? 'choose_image' : 'update_image'"
              :required="isNewItem"
            />
            <app-row>
              <app-text-input
                v-model="selectedItem.name_ar"
                cols="12"
                name="name_ar"
                required
                sm="6"
              />
              <app-text-input
                v-model="selectedItem.name_en"
                cols="12"
                name="name_en"
                required
                sm="6"
              />
              <app-text-input
                v-model="selectedItem.url"
                clearable
                cols="12"
                name="url"
                sm="6"
              />
              <app-number-input
                v-model="selectedItem.order_by"
                cols="12"
                name="order_by"
                sm="6"
              />
            </app-row>
            <v-row align="center">
              <app-switcher
                v-model="selectedItem.active"
                cols="auto"
                name="active"
              />
            </v-row>
          </v-container>
        </app-form>
      </template>

      <template #item.control="{item}">
        <app-dt-btn
          v-if="userHasPermission('update')"
          :disabled="loadingDatatable"
          update
          @click="showUpdateDialog(item)"
        />
        <app-dt-btn
          v-if="userHasPermission('destroy')"
          :disabled="loadingDatatable"
          destroy
          @click="deleteItem(item)"
        />
      </template>

      <template #item.avatar="{item}">
        <app-dt-avatar
          v-if="item.avatar"
          :src="item.avatar"
        />
      </template>

      <template #item.url="{item}">
        <app-btn
          v-if="item.url"
          :href="item.url"
          target="_blank"
          text
        >
          {{ $t('view') }}
        </app-btn>
      </template>
    </app-datatable>
  </app-card>
</template>
<script>
import { AvatarInputMixin, DatatableMixin, MetaInfoMixin } from '@mixins'

export default {
  name: 'Offers',
  helperApiName: 'offer',
  mixins: [MetaInfoMixin, DatatableMixin, AvatarInputMixin],
  data () {
    return {
      modelPermission: 'Utilities.Offer',
      headers: [
        {
          text: 'avatar',
          value: 'avatar',
          width: 100
        },
        'name',
        'url',
        {
          text: 'status',
          value: 'active_to_string'
        },
        'order_by',
        'control'
      ]
    }
  },
  computed: {
    defaultSelectedItem () {
      return {
        order_by: 0,
        active: !0
      }
    }
  },
  mounted () {
    this.checkPermission('index')
  }
}
</script>
